import React, {Component} from "react";
import {Alert, Button, Form, Table} from "react-bootstrap";
import {AppContext} from "../../AppContext";
import axios from "axios";

/**
 * Ustawienia przypomnień handlowych (ADMIN) - treść pytania, cykl w miesiącach, włączenie.
 * Dzięki temu zmiana cyklu (np. z 3 na 6 miesięcy) nie wymaga zmiany kodu ani nowej wersji
 * aplikacji mobilnej.
 */
class ReminderSettings extends Component {

    static contextType = AppContext;

    state = {
        types: [],
        isLoading: true,
        message: '',
        messageVariant: 'success'
    }

    componentDidMount() {
        this.loadTypes();
    }

    loadTypes = () => {
        axios.get(`${this.context.hostname}/api/reminder/types`, {
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json"},
            withCredentials: true
        }).then(res => {
            this.setState({types: res.data, isLoading: false});
        }).catch((error) => {
            console.log({error});
            this.setState({isLoading: false, message: 'Nie udało się pobrać ustawień przypomnień.', messageVariant: 'danger'});
        });
    }

    handleChange = (id, field, value) => {
        this.setState({
            types: this.state.types.map(type =>
                type.id === id ? {...type, [field]: value} : type)
        });
    }

    handleSave = (type) => {
        if (!type.periodMonths || parseInt(type.periodMonths, 10) < 1) {
            this.setState({message: 'Cykl musi wynosić co najmniej 1 miesiąc.', messageVariant: 'danger'});
            return;
        }
        axios.put(`${this.context.hostname}/api/reminder/types/${type.id}`, {
            question: type.question,
            periodMonths: parseInt(type.periodMonths, 10),
            active: type.active,
            order: type.order
        }, {
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json"},
            withCredentials: true
        }).then(() => {
            this.setState({message: 'Zapisano ustawienia przypomnienia.', messageVariant: 'success'});
            this.loadTypes();
        }).catch((error) => {
            console.log({error});
            const status = error.response && error.response.status;
            this.setState({
                message: status === 403
                    ? 'Ustawienia przypomnień może zmieniać tylko administrator.'
                    : 'Nie udało się zapisać ustawień.',
                messageVariant: 'danger'
            });
        });
    }

    render() {
        return (
            <div>
                <h5>Przypomnienia handlowe</h5>
                <Alert variant='secondary' style={{padding: '5px 10px', fontSize: 13}}>
                    Pytania pokazują się serwisantom po podpisaniu protokołu serwisowego, gdy minie cykl
                    dla danego kontrahenta. Odpowiedzi są materiałem wewnętrznym — nie trafiają do protokołu PDF.
                </Alert>

                {this.state.message !== '' &&
                    <Alert variant={this.state.messageVariant} style={{padding: '5px 10px'}}>{this.state.message}</Alert>
                }
                {this.state.isLoading && <div>Wczytywanie...</div>}

                {!this.state.isLoading &&
                    <Table bordered hover size="sm" style={{fontSize: 13}}>
                        <thead>
                        <tr>
                            <th style={{width: '45%'}}>Pytanie</th>
                            <th>Cykl (mies.)</th>
                            <th>Aktywne</th>
                            <th>Weryfikacja</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.types.map(type =>
                            <tr key={type.id}>
                                <td>
                                    <Form.Control
                                        type="text"
                                        size="sm"
                                        value={type.question}
                                        onChange={(e) => this.handleChange(type.id, 'question', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        min="1"
                                        style={{width: 80}}
                                        value={type.periodMonths}
                                        onChange={(e) => this.handleChange(type.id, 'periodMonths', e.target.value)}
                                    />
                                </td>
                                <td style={{textAlign: 'center'}}>
                                    <Form.Check
                                        type="checkbox"
                                        checked={type.active}
                                        onChange={(e) => this.handleChange(type.id, 'active', e.target.checked)}
                                    />
                                </td>
                                <td style={{fontSize: 11}}>
                                    {type.verifyByInfoCard
                                        ? 'automatyczna — po dacie karty informacyjnej'
                                        : 'ręczna — po odpowiedzi serwisanta'}
                                </td>
                                <td>
                                    <Button variant="outline-dark" size="sm" onClick={() => this.handleSave(type)}>
                                        Zapisz
                                    </Button>
                                </td>
                            </tr>
                        )}
                        {this.state.types.length === 0 &&
                            <tr>
                                <td colSpan="5" style={{fontStyle: 'italic'}}>Brak zdefiniowanych przypomnień.</td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                }
            </div>
        );
    }
}

export default ReminderSettings;
